import React, { useState } from 'react';
import styles from './JoinRoommateGroup.module.css';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const JoinRoommateGroup = ({ tenantId, refreshGroupStatus }) => {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('Roommate');
  console.log(tenantId);

  const handleSubmit = async () => {
    await fetch(`${API_BASE_URL}/roommates/group/add`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, role, addedByTenantId: tenantId }),
    });
    refreshGroupStatus();
  };

  return (
    <div className={styles.welcomeContainer}>
      <h2>Join or Create a Roommate Group</h2>
      <p>Enter your roommate's email to start forming your roommate group!</p>
      
      <input
        type="email"
        placeholder="Roommate's Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className={styles.inputField}
      />

      <select value={role} onChange={(e) => setRole(e.target.value)} className={styles.inputField}>
        <option value="Roommate">Roommate</option>
        <option value="Cosigner">Cosigner</option>
      </select>

      <button className={styles.joinBtn} onClick={handleSubmit}>
        Create/Join Group
      </button>
    </div>
  );
};

export default JoinRoommateGroup;
